import { IExtraMedicine, IValidatePrescription } from '@/interfaces';
import NetworkService, { Endpoint } from './NetworkService'
import IPrescription from '@/interfaces/IPrescription';
import { v4 as uuidv4 } from 'uuid';
import qs from 'qs'

export default class PrescriptionsService extends NetworkService {
    constructor() {
        super()
    }

    validatePrescription(params: IValidatePrescription) {
        return this.get(Endpoint.validatePrescription, params);
    }

    show = async (params: IValidatePrescription) => {
        const res = await this.get(Endpoint.prescriptions, params);
        res.data = this.preparePrescription(res.data);
        return res
    };

    dismissMedicine = async (medicine: any, prescription: IPrescription) => {
        if (medicine.extra) {
            const res = await this.show({ code: prescription.code, token: prescription.token })
            const formatted = this.preparePrescription(res.data)
            const drugs_extra = formatted.extra_drugs
                .filter((elem: any) => elem.extra)
                .map((elem: IExtraMedicine) => {
                    let med = elem.id === medicine.id ? { ...elem, dismissed: !elem.dismissed } : elem
                    return this.formatExtraMedicine(med)
                })
                .join('|')
            const params = { drugs_extra }
            return this.put(`${Endpoint.extraMedicines}/${prescription.id}`, params)
        } else {
            const params = {
                dismissed: !medicine.dismissed,
                drug_recipe_id: medicine.id
            }
            return this.post(Endpoint.dismissMedicine, params)
        }
    }

    singleMedicinePDF = (params: any) => {
        const url = `${this.baseUrl}${Endpoint.singleMedicinePDF}?${qs.stringify(params)}`
        window.open(url, "_blank");
    }

    preparePrescription = (data: IPrescription) => {
        if (data.drugs_extra) {
            const drugs_extra: any = data.drugs_extra.split('|')
            data.extra_drugs = []
            drugs_extra.map((drug: any) => {
                const [name, dosage, dose, qty, id, dismissed] = drug.split(';')
                const medicine = {
                    id: id || uuidv4(),
                    drug_name: { name },
                    dosage, dose, qty, dismissed: dismissed === 'true' ? true : false,
                    extra: true
                }
                data.drugs.push(medicine)
                data.extra_drugs.push(medicine)
            })
        }
        data.dismissed_drugs = data.drugs.filter(drug => drug.dismissed)
        return data
    }

    formatExtraMedicine(medicine: IExtraMedicine): string {
        return `${medicine.drug_name.name};${medicine.dosage};${medicine.dose};${medicine.qty};${medicine.id};${medicine.dismissed}`;
    }
}